// src/components/ProtectedRoute.js
import { Navigate, useLocation } from "react-router-dom";
import { getAdminPagePermission } from "../utils/adminPagePermissions";
import { useAuth } from "../contexts/AuthContext";
import { useCompany } from "../contexts/CompanyContext";
import LoadingIndicator from "./LoadingIndicator";

export default function ProtectedRoute({ children, requireAdmin = true }) {
  const { currentUser, loading: authLoading } = useAuth();
  const { activeCompany, loading: companyLoading, permissionsLoading, canAccessPage } = useCompany();

  const { pathname } = useLocation();

  // Visa laddningsindikator medan vi kontrollerar autentisering
  if (authLoading || companyLoading || permissionsLoading) {
    return (
      <div style={{ minHeight: "100vh", background: "#f9fafb", display: "grid", placeItems: "center" }}>
        <LoadingIndicator message="Laddar..." fullPage />
      </div>
    );
  }

  // Om användaren inte är inloggad, redirect till login
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  // Om routen kräver admin-behörighet, kolla rollen från activeCompany
  if (requireAdmin) {
    const userRole = activeCompany?.role;
    const isAdminOrSuperAdmin = userRole === "admin" || userRole === "super-admin";
    
    if (!isAdminOrSuperAdmin) {
      console.log("Åtkomst nekad: Användaren är inte admin eller super-admin för detta företag. Roll:", userRole);
      return <Navigate to="/dashboard" replace />;
    }
  }

  if (pathname.toLowerCase().startsWith("/super-admin/") && activeCompany?.role !== "super-admin") {
    return <Navigate to="/shifts" replace />;
  }

  const page = getAdminPagePermission(pathname);
  if (page && !canAccessPage(page)) return <Navigate to="/shifts" replace />;

  // Annars visa barnkomponenterna
  return children;
}
